{
  "accountantActivity": {
    "title": "Accountant Activity",
    "subtitle": "Daily SoD audit — monetary-action volume per accountant/admin vs their 30-day baseline (flag: >10x baseline and >=5 actions)",
    "redFlagOnly": "Red flags only",
    "loading": "Loading…",
    "empty": "No reports yet — the 02:00 UTC audit cron writes one per day",
    "emptyDetail": "No user activity recorded for this day",
    "detailTitle": "Report detail — {{date}}",
    "flaggedGeneric": "flagged",
    "columns": {
      "date": "Date",
      "generatedAt": "Generated",
      "totalEvents": "Total events",
      "redFlags": "Red flags",
      "digestRecipients": "Digest sent to",
      "user": "User",
      "role": "Role",
      "creditMemos": "Credit memos",
      "markPaid": "Mark paid",
      "refundTasks": "Refund tasks",
      "total": "Total",
      "baseline": "30d baseline",
      "flagged": "Flagged"
    }
  },
  "auth": {
    "login": {
      "title": "Welcome back",
      "subtitle": "Sign in to your account",
      "lockout": {
        "before": "Account locked. Unlocks in"
      },
      "emailLabel": "Email",
      "emailPlaceholder": "name@company.com",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Enter your password",
      "showPassword": "Show password",
      "hidePassword": "Hide password",
      "forgotPassword": "Forgot password?",
      "submit": "Login",
      "submitting": "Signing in…",
      "or": "OR",
      "continueLark": "Continue with Lark Suite",
      "noRegisterNotice": "Admin accounts are provisioned by Superadmin only.",
      "validation": {
        "emailInvalid": "Invalid email",
        "passwordMin": "Password must be at least 8 characters",
        "passwordMax": "Password must be at most 128 characters"
      },
      "stepUp": {
        "prompt": "For security reasons, please enter the OTP sent to your email.",
        "otpLabel": "OTP code (6 digits)",
        "otpInvalid": "OTP must be 6 digits.",
        "otpWrong": "OTP is incorrect or has expired.",
        "verify": "Verify OTP",
        "cancel": "Cancel"
      },
      "errors": {
        "invalidCredentials": "Incorrect email or password.",
        "recaptchaFailed": "reCAPTCHA verification failed — please try again.",
        "emailUnverified": "Email not verified. Contact Superadmin.",
        "twoFaRequired": "Two-factor authentication required — enter the code from your authenticator app.",
        "accountLocked": "Account temporarily locked after too many failed attempts. Please wait a few minutes and try again.",
        "accountLockedCountdown": "Account temporarily locked after too many failed attempts. Unlocks in {{time}}.",
        "pendingApproval": "Your vendor account is awaiting admin approval.",
        "rateLimit": "Too many attempts — please wait 15 minutes.",
        "validationFailed": "The information entered is invalid.",
        "authRequired": "Please sign in to continue.",
        "forbidden": "This account does not have access.",
        "default": "Login failed. Please try again."
      }
    },
    "forgot": {
      "title": "Forgot password",
      "subtitle": "Enter your account email — we'll send you a password reset link.",
      "emailLabel": "Email",
      "emailPlaceholder": "you@company.com",
      "submit": "Send reset link",
      "submitting": "Sending...",
      "backToLogin": "Back to sign in",
      "validation": {
        "emailInvalid": "Invalid email"
      },
      "success": {
        "title": "Check your inbox",
        "descBefore": "If",
        "descAfter": "is registered, you'll receive a password reset link within a few minutes. The link is valid for 15 minutes."
      }
    },
    "reset": {
      "title": "Set a new password",
      "subtitle": "Your password must meet all the requirements below.",
      "newPasswordLabel": "New password",
      "confirmPasswordLabel": "Confirm password",
      "rulesAria": "Password requirements",
      "submit": "Set new password",
      "submitting": "Processing...",
      "backToLogin": "Back to sign in",
      "rules": {
        "len": "At least 12 characters",
        "upper": "At least 1 uppercase letter",
        "num": "At least 1 number",
        "special": "At least 1 special character"
      },
      "validation": {
        "lenMin": "Password must be at least 12 characters",
        "upper": "At least 1 uppercase letter required",
        "num": "At least 1 number required",
        "special": "At least 1 special character required",
        "confirmRequired": "Please confirm your password",
        "mismatch": "Passwords do not match"
      },
      "flash": {
        "title": "Password reset successful",
        "desc": "Please sign in with your new password."
      },
      "errors": {
        "reused": "This password was used recently. Please choose a different one.",
        "requestFailed": "Request failed (HTTP {{status}})",
        "unknown": "Unknown error"
      },
      "invalid": {
        "title": "Invalid link",
        "desc": "The reset link has been used or has expired (15 minutes). Please request a new link.",
        "requestNew": "Request a new link"
      },
      "validating": "Checking your reset link…"
    },
    "verify2fa": {
      "title": "Two-step verification (Admin)",
      "headlineEmail": "Enter the OTP sent to your email",
      "headlineTotp": "Enter the code from your authenticator app (TOTP — Time-based One-Time Password)",
      "codeLabel": "6-digit code",
      "codeAria": "6-digit code",
      "trustDevice": "Trust this device for 30 days",
      "submit": "Confirm",
      "submitting": "Verifying…",
      "backToLogin": "Back to sign in",
      "recoveryHint": "Lost your authenticator device? Contact the Superadmin to recover.",
      "errors": {
        "incomplete": "Please enter all 6 digits.",
        "sessionExpired": "Your verification session has expired — please sign in again.",
        "expired": "The code has expired — please sign in again.",
        "tooMany": "Too many attempts — please wait 15 minutes.",
        "invalid": "The verification code is incorrect."
      }
    }
  },
  "setup": {
    "wizard": {
      "title": "Printway — Initial Setup",
      "subtitle": "Complete 3 steps to initialize the Super Admin account",
      "progressAria": "Setup wizard progress",
      "steps": {
        "step1": "Create Super Admin",
        "step2": "Enable 2FA (two-factor)",
        "step3": "Recovery codes"
      }
    },
    "createAdmin": {
      "heading": "Step 1 — Create the Super Admin account",
      "descriptionBefore": "This account will be the system owner. The email must use the internal domain",
      "descriptionAfter": ".",
      "emailLabel": "Super Admin email",
      "nameLabel": "Display name",
      "namePlaceholder": "Founding Admin",
      "passwordLabel": "Password",
      "passwordHint": "At least 12 characters (per policy).",
      "confirmPasswordLabel": "Confirm password",
      "acceptTerms": "I agree to the Printway terms of service and accept responsibility for managing this Super Admin account.",
      "submit": "Continue → Step 2",
      "submitting": "Creating…",
      "validation": {
        "emailRequired": "Email is required",
        "emailInvalid": "Invalid email",
        "emailDomain": "Email must end with @printway.work",
        "nameRequired": "Display name is required",
        "passwordMin": "Password must be at least 12 characters",
        "passwordMax": "Password must not exceed 128 characters",
        "acceptTermsRequired": "You must agree to the terms of service",
        "passwordMismatch": "Passwords do not match"
      },
      "errors": {
        "missingToken": "Missing setup token. Reopen the link issued during deployment.",
        "createFailed": "Could not create the Super Admin — please try again"
      }
    },
    "enable2fa": {
      "heading": "Step 2 — Enable two-factor authentication (2FA)",
      "descriptionBefore": "Scan the QR code with an Authenticator app (Google Authenticator, 1Password, Authy…) then enter the 6-digit code to confirm. This step is ",
      "descriptionRequired": "required",
      "descriptionAfter": ".",
      "qrAlt": "TOTP QR code (QR code to configure your authenticator)",
      "qrGenerating": "Generating QR code…",
      "qrError": "Could not generate the QR code — use the manual key below.",
      "manualKeyLabel": "Manual key (enter manually if you can't scan the QR):",
      "manualKeyMissing": "(No manual key available — scan the QR above)",
      "accountLabel": "Account: {{email}}",
      "emailUnknown": "(unknown)",
      "issuerLabel": "Issuer:",
      "totpCodeLabel": "6-digit verification code",
      "submit": "Verify → Step 3",
      "submitting": "Verifying…",
      "validation": {
        "totpFormat": "The TOTP code must be exactly 6 digits"
      },
      "errors": {
        "missingSetupToken": "Missing setup token — go back to step 1 and try again.",
        "missingEnrollToken": "Missing enrollment token (TOTP) — go back to step 1 and try again.",
        "verifyFailed": "Incorrect TOTP code — please try again"
      }
    },
    "recoveryCodes": {
      "heading": "Step 3 — Recovery codes",
      "descriptionBefore": "These are 8 one-time recovery codes (used if you lose your 2FA device). ",
      "descriptionStrong": "Shown only this once",
      "descriptionAfter": ". Download and store them offline in a safe place (safe, password manager).",
      "generating": "Generating recovery codes…",
      "download": "Download recovery-codes.txt",
      "ackStrong": "Saved in a safe place.",
      "ackRest": " I understand these recovery codes will not be shown again — if lost, I will need to reset 2FA through the support process.",
      "complete": "Finish → Sign in",
      "completing": "Redirecting…",
      "errors": {
        "missingToken": "Missing setup token — go back to step 1 and start over.",
        "loadFailed": "Could not load recovery codes — please try again"
      },
      "bannerTitle": "Printway — Recovery Codes (Super Admin)",
      "bannerNote": "Store this file somewhere safe (offline). Each code can be used only once."
    },
    "errors": {
      "httpFailed": "Request failed (HTTP {{status}})"
    }
  },
  "profile": {
    "account": {
      "title": "My account",
      "subtitle": "Manage your personal information, security and login sessions.",
      "tabsAria": "Account sections",
      "formAria": "Profile form",
      "loading": "Loading account information…",
      "loadError": "Failed to load account",
      "tabs": {
        "profile": "Profile",
        "security": "Security",
        "notifications": "Notifications",
        "preferences": "Preferences",
        "activity": "Activity"
      },
      "fields": {
        "email": "Email",
        "role": "Role",
        "firstName": "First name",
        "lastName": "Last name",
        "phone": "Phone number",
        "country": "Country",
        "avatarUrl": "Avatar (URL)"
      },
      "emailReadonly": "Email cannot be edited.",
      "saveErrorFallback": "Failed to save changes",
      "saveSuccess": "Changes saved.",
      "save": "Save changes",
      "saving": "Saving…",
      "security": {
        "passwordTitle": "Change password",
        "passwordDesc": "Change your password by entering your current password and a new one.",
        "changePassword": "Change password",
        "twoFactorTitle": "Two-factor authentication (2FA)",
        "twoFactorStatus": "Status:",
        "twoFactorOn": "Enabled",
        "twoFactorOff": "Not enabled",
        "twoFactorDesc": "Enable two-factor authentication to better secure your account (choose TOTP or email OTP).",
        "sessionsTitle": "Login sessions",
        "manageSessions": "Manage login sessions",
        "enableTwoFactor": "Enable 2FA",
        "manageTwoFactor": "Manage 2FA"
      },
      "notifications": {
        "category": "Category",
        "quietHours": "Quiet hours",
        "quietHoursDesc": "Pause push notifications during these hours.",
        "channels": {
          "email": "Email",
          "push": "Push",
          "in_app": "In-app"
        },
        "categories": {
          "orders": "Orders",
          "shipping": "Shipping",
          "payment": "Payment",
          "wallet": "Wallet",
          "billing": "Billing",
          "system": "System",
          "marketing": "Marketing"
        },
        "testEmail": "Test email",
        "testEmailDesc": "Send a sample notification email to your account address.",
        "testEmailSend": "Send test email",
        "testEmailSending": "Sending…",
        "testEmailSent": "Test email sent. Check your inbox.",
        "testEmailNotSent": "Test email could not be sent. Please try again.",
        "testEmailError": "Could not send test email. Please try again."
      },
      "preferences": {
        "groups": {
          "regional": "Regional",
          "display": "Display",
          "email": "Email"
        },
        "fields": {
          "language": "Language",
          "currency": "Currency",
          "dateFormat": "Date format",
          "timezone": "Timezone",
          "theme": "Theme",
          "density": "Density",
          "dashboardView": "Dashboard view",
          "emailDigest": "Email digest"
        },
        "options": {
          "theme": {
            "system": "System",
            "light": "Light",
            "dark": "Dark",
            "auto": "Auto"
          },
          "density": {
            "normal": "Normal",
            "compact": "Compact"
          },
          "dashboardView": {
            "expanded": "Expanded",
            "compact": "Compact"
          },
          "emailDigest": {
            "none": "None",
            "daily": "Daily",
            "weekly": "Weekly",
            "monthly": "Monthly"
          }
        },
        "descriptions": {
          "regional": "Language, currency, and date/time formatting.",
          "display": "Appearance theme."
        },
        "themeHints": {
          "light": "Bright theme",
          "dark": "Dim theme",
          "system": "Match device setting",
          "auto": "Light 6:00–18:00, dark after"
        }
      },
      "activity": {
        "empty": "No recent account activity."
      }
    },
    "sessions": {
      "title": "Active login sessions",
      "subtitle": "List of devices / browsers currently accessing your account.",
      "tableAria": "Active sessions",
      "revokeAll": "Revoke all",
      "revokingAll": "Revoking…",
      "revokeOneSuccess": "Login session revoked.",
      "revokeOneError": "Failed to revoke session",
      "revokeAllSuccess_one": "Revoked {{count}} session.",
      "revokeAllSuccess_other": "Revoked {{count}} sessions.",
      "revokeAllError": "Failed to revoke all sessions",
      "loading": "Loading sessions…",
      "loadError": "Failed to load session list",
      "empty": "No login sessions found.",
      "columns": {
        "device": "Device",
        "ip": "IP",
        "start": "Started",
        "lastSeen": "Last active",
        "actions": "Actions"
      },
      "currentBadge": "Current session",
      "emptyUserAgent": "Empty User-Agent",
      "revoke": "Revoke",
      "revoking": "Revoking…",
      "deviceLabels": {
        "unknown": "Unknown",
        "browser": "Browser"
      },
      "browserLabels": {
        "other": "Other"
      },
      "activeTitle": "Active sessions",
      "activeSubtitle": "Devices currently signed into your account. Revoke any session you do not recognize.",
      "deviceOn": "on",
      "signOut": "Sign out"
    },
    "preferences": {
      "title": "Preferences",
      "subtitle": "Customize appearance, language, timezone and notifications.",
      "formAria": "Preferences form",
      "loading": "Loading preferences…",
      "loadError": "Failed to load preferences",
      "theme": {
        "legend": "Appearance",
        "light": "Light",
        "dark": "Dark",
        "system": "System"
      },
      "language": {
        "label": "Language"
      },
      "timezone": {
        "label": "Timezone"
      },
      "dateFormat": {
        "label": "Date format"
      },
      "notifications": {
        "legend": "Notifications",
        "emailLabel": "Receive email",
        "emailDesc": "Non-mandatory notifications; transactional emails (password reset, 2FA) are always sent.",
        "smsLabel": "Receive SMS"
      },
      "saveErrorFallback": "Failed to save preferences",
      "saveSuccess": "Preferences saved.",
      "save": "Save preferences",
      "saving": "Saving…"
    },
    "loginHistory": {
      "title": "Login history",
      "tableAria": "Login history",
      "subtitle": "Recent successful and failed login attempts on your account.",
      "columns": {
        "status": "Status",
        "ts": "Timestamp",
        "ip": "IP",
        "device": "Device",
        "browser": "Browser",
        "reason": "Reason"
      },
      "filter": {
        "from": "From",
        "to": "To"
      },
      "loading": "Loading…",
      "loadError": "Could not load login history.",
      "empty": "No login attempts in this range.",
      "pager": {
        "aria": "Pagination",
        "pageSize": "Rows per page",
        "total": "{{total}} records",
        "prev": "Prev",
        "next": "Next"
      }
    },
    "activity": {
      "viewLoginHistory": "View login history"
    }
  },
  "auditLog": {
    "page": {
      "title": "Audit Log",
      "subtitle": "System-wide audit trail. Read-only, immutable."
    },
    "actions": {
      "exportCsv": "Export CSV",
      "view": "View",
      "loadMore": "Load more",
      "loading": "Loading…"
    },
    "columns": {
      "timestamp": "Timestamp",
      "actor": "Actor",
      "action": "Action",
      "entity": "Entity",
      "details": "Details"
    },
    "loading": "Loading audit log…",
    "empty": {
      "title": "No log entries",
      "body": "Try adjusting the filters or widening the date range."
    },
    "footer": {
      "showing_one": "Showing {{count}} entry",
      "showing_other": "Showing {{count}} entries",
      "loadingMore": " • loading more…"
    },
    "drawer": {
      "title": "Audit entry — {{action}}",
      "close": "Close"
    },
    "fields": {
      "timestamp": "Timestamp",
      "actor": "Actor",
      "action": "Action",
      "entity": "Entity",
      "requestId": "Request ID",
      "merchantId": "Merchant ID",
      "ip": "IP",
      "userAgent": "User Agent"
    },
    "json": {
      "oldValue": "Old value",
      "newValue": "New value",
      "metadata": "Metadata"
    },
    "relative": {
      "seconds": "{{count}}s ago",
      "minutes": "{{count}}m ago",
      "hours": "{{count}}h ago",
      "days": "{{count}}d ago",
      "months": "{{count}}mo ago",
      "years": "{{count}}y ago"
    },
    "filters": {
      "actorLabel": "Actor email",
      "actorPlaceholder": "search by email…",
      "searchLabel": "Search",
      "searchPlaceholder": "search action, target id, email…",
      "searchAria": "Free-text search",
      "clear": "Clear filters",
      "dateRange": "Date range",
      "from": "From",
      "to": "To",
      "action": "Action",
      "entityType": "Entity type"
    },
    "presets": {
      "7d": "Last 7 days",
      "30d": "Last 30 days",
      "90d": "Last 90 days",
      "custom": "Custom range"
    },
    "toast": {
      "loadFailTitle": "Failed to load audit log",
      "unknown": "Unknown"
    }
  },
  "audit": {
    "loading": "Loading audit log…",
    "empty": {
      "title": "No log entries",
      "body": "Try adjusting the filters or widening the date range."
    },
    "errors": {
      "loadFailed": "Unable to load the audit log"
    },
    "columns": {
      "timestamp": "Timestamp",
      "actor": "Actor",
      "role": "Role",
      "entity": "Entity",
      "entityId": "Entity ID",
      "action": "Action",
      "ip": "IP",
      "userAgent": "User Agent",
      "diff": "Diff",
      "severity": "Severity"
    },
    "filters": {
      "action": "Action",
      "allActions": "— All actions —",
      "entityType": "Entity type",
      "allEntities": "— All 24 entities —",
      "actorUserId": "Actor user ID",
      "actorUserIdPlaceholder": "ObjectId (24 hex)",
      "actorRole": "Actor role",
      "all": "— All —",
      "severity": "Severity",
      "dateFrom": "From date",
      "dateTo": "To date",
      "search": "Search (q)",
      "searchPlaceholder": "Action/entity/IP/UA…",
      "clear": "Clear all filters"
    },
    "footer": {
      "showing_one": "Showing {{count}} entry",
      "showing_other": "Showing {{count}} entries",
      "loadingMore": " • loading more…"
    },
    "actions": {
      "loadMore": "Load more",
      "loading": "Loading…"
    },
    "relativeAgo": "{{value}} ago",
    "diff": {
      "changesAria_one": "{{count}} change",
      "changesAria_other": "{{count}} changes",
      "viewTooltip": "Click to view diff",
      "noChanges": "This event did not change any data (no diff to display).",
      "columnField": "Field (key-path)",
      "columnBefore": "Before",
      "columnAfter": "After",
      "collapse": "Collapse",
      "expandAll": "View all ({{count}} items)",
      "truncated": "Diff truncated — only the first 50 fields are shown. Open \"View full JSON\" to see the entire payload.",
      "showJson": "View full JSON",
      "hideJson": "Hide full JSON",
      "rawBefore": "Before (raw)",
      "rawAfter": "After (raw)",
      "kind": {
        "added": "+ Added",
        "removed": "- Removed",
        "modified": "~ Modified",
        "unchanged": "= Unchanged"
      }
    },
    "multiSelect": {
      "all": "— All —",
      "selectedCount": "{{count}} selected",
      "filterPlaceholder": "Filter options…",
      "noMatch": "No matching options",
      "clearAll": "Clear all",
      "close": "Close"
    },
    "archive": {
      "bannerTitle": "Searching cold storage (S3) — results may take up to 30 seconds.",
      "bannerBody": "Only records older than 180 days are shown. Personal data (PII) is pseudonymized before it is returned.",
      "dateFrom": "From date *",
      "dateTo": "To date *",
      "actorPlaceholder": "ObjectId / pseudonymized",
      "searchPlaceholder": "Free-text query — action/entity/ip…",
      "scanning": "Scanning S3",
      "estimate": " (~{{seconds}}s)",
      "runButton": "Search cold storage",
      "unavailable": "Cold storage is temporarily unavailable",
      "idlePrefix": "Select a date range (older than 180 days) and click ",
      "idleSuffix": " to start.",
      "pseudonymized": "PII pseudonymized",
      "scanned_one": "Scanned {{count}} S3 object",
      "scanned_other": "Scanned {{count}} S3 objects",
      "searching": "Searching cold storage…",
      "empty": "No records found in cold storage for this date range."
    },
    "actionLabels": {
      "AUTH_USER_UPDATE": "User — Update",
      "AUTH_PROFILE_UPDATE": "Profile — Update",
      "AUTH_USER_SUSPEND": "User — Suspend",
      "AUTH_USER_UNSUSPEND": "User — Unsuspend",
      "AUTH_USER_ROLE_GRANT": "User — Role Grant",
      "AUTH_USER_ROLE_REVOKE": "User — Role Revoke",
      "AUTH_2FA_SETUP": "2FA — Setup",
      "AUTH_2FA_DISABLED": "2FA — Disabled",
      "AUTH_2FA_VERIFY": "2FA — Verify",
      "AUTH_USER_2FA_RESET": "2FA — Reset by Admin",
      "AUTH_BILLING_UPDATE": "Billing — Update",
      "AUTH_LOGIN_FAILED": "Auth — Login Failed",
      "AUTH_LOGIN_LOCKED": "Auth — Login Locked",
      "ADMIN_ROLE_CREATE": "Role — Create",
      "ADMIN_ROLE_UPDATE": "Role — Update",
      "ADMIN_ROLE_DELETE": "Role — Delete",
      "AUTH_LOGIN": "Auth — Login",
      "AUTH_LOGOUT": "Auth — Logout",
      "AUTH_REGISTER": "Auth — Register",
      "AUTH_OTP_VERIFY": "Auth — OTP Verify",
      "AUTH_OTP_RESEND": "Auth — OTP Resend",
      "AUTH_PASSWORD_CHANGE": "Auth — Password Change",
      "AUTH_PASSWORD_RESET": "Auth — Password Reset",
      "AUTH_PASSWORD_RESET_REQUESTED": "Auth — Password Reset Requested",
      "AUTH_REFRESH": "Auth — Token Refresh",
      "AUTH_TOKEN_REUSE": "Auth — Token Reuse Detected",
      "AUTH_OAUTH_LOGIN_INITIATED": "Auth — OAuth Login Initiated",
      "AUTH_OAUTH_CALLBACK_SUCCESS": "Auth — OAuth Callback Success",
      "AUTH_OAUTH_CALLBACK_FAILED": "Auth — OAuth Callback Failed",
      "AUTH_SIGNUP_COUNTRY_MISMATCH": "Auth — Signup Country Mismatch",
      "AUTH_SURVEY_SUBMIT": "Auth — Survey Submit",
      "AUTH_IMPERSONATE_START": "Impersonate — Start",
      "AUTH_IMPERSONATE_END": "Impersonate — End",
      "AUTH_IMPERSONATE_LANDING": "Impersonate — Landing",
      "AUTH_EMERGENCY_MODE_ACTIVATE": "Impersonate — Emergency Mode",
      "SETUP_INIT": "Setup — Init",
      "SETUP_COMPLETED": "Setup — Completed",
      "AUTH_TEAM_INVITE": "Team — Invite",
      "AUTH_TEAM_INVITE_COMPLETE": "Team — Invite Complete",
      "AUTH_TEAM_SUSPEND": "Team — Suspend",
      "AUTH_TEAM_UNSUSPEND": "Team — Unsuspend",
      "AUTH_TEAM_REASSIGN": "Team — Reassign",
      "MEMBER_SOFT_DELETED": "Member — Soft Deleted",
      "MEMBER_UPDATED": "Member — Updated",
      "LIMIT_REQUEST_SUBMITTED": "Limit Request — Submitted",
      "LIMIT_REQUEST_APPROVED": "Limit Request — Approved",
      "LIMIT_REQUEST_REJECTED": "Limit Request — Rejected",
      "LIMIT_REQUEST_CANCELLED": "Limit Request — Cancelled",
      "TWO_FA_RESET_BY_ADMIN": "2FA — Reset by Admin",
      "CASHBACK_CREDIT": "Billing — Cashback Credit",
      "REFUND_CREATE": "Billing — Refund Create",
      "INTERNAL_AUTH_REJECTED": "Internal — Auth Rejected"
    },
    "entityTypeLabels": {
      "User": "User",
      "Team": "Team",
      "TeamMember": "Team Member",
      "Merchant": "Merchant",
      "Role": "Role",
      "Permission": "Permission",
      "LimitRequest": "Limit Request",
      "TopupRequest": "Topup Request",
      "WithdrawRequest": "Withdraw Request",
      "Chargeback": "Chargeback",
      "Wallet": "Wallet",
      "Session": "Session",
      "Orders": "Orders",
      "Users": "Users (admin staff)",
      "Products": "Products",
      "Finance": "Finance",
      "Merchants": "Merchants",
      "Vendors": "Vendors",
      "Stores": "Stores",
      "SupportTickets": "Support Tickets",
      "Settings": "System Settings",
      "FeatureFlags": "Feature Flags",
      "KYCDocuments": "KYC Documents",
      "Payouts": "Payouts",
      "ImpersonationSessions": "Impersonation Sessions",
      "ApprovalRequests": "Approval Requests",
      "Addons": "Add-ons",
      "BlueprintsAdmin": "Blueprints (admin)",
      "Bundles": "Bundles",
      "Categories": "Categories",
      "Collections": "Collections",
      "CreditMemos": "Credit Memos",
      "LegalEntities": "Legal Entities",
      "PendingApprovals": "Pending Approvals",
      "PrepaymentRequests": "Prepayment Requests",
      "Pricing": "Pricing",
      "ProductsSpecial": "Products Special",
      "RefundTasks": "Refund Tasks",
      "RegionErrors": "Region Errors",
      "Templates": "Templates",
      "Techniques": "Techniques",
      "Tickets": "Tickets",
      "TicketMessages": "Ticket Messages",
      "RoleChanges": "Role Changes",
      "APIKeyAccess": "API Key Access",
      "PermissionGrants": "Permission Grants",
      "EmergencyMode": "Emergency Mode",
      "AuditExport": "Audit Export",
      "RetentionConfig": "Retention Config",
      "CustomRoleCRUD": "Custom Role CRUD",
      "FeatureFlagChanges": "Feature Flag Changes",
      "Inventory": "Inventory",
      "MerchantTransferBlock": "Merchant Transfer Block"
    },
    "actorRoleLabels": {
      "superadmin": "Superadmin",
      "admin": "Admin",
      "support_admin": "Support Admin",
      "accountant": "Accountant",
      "system": "System"
    },
    "severityLabels": {
      "info": "Info",
      "warning": "Warning",
      "security": "Security"
    }
  },
  "dualApproval": {
    "reasonTooShort": "Reason must be at least 10 characters.",
    "actionTypes": {
      "refund_large": "Refund (large)",
      "vendor_wallet_debit_large": "Vendor wallet debit (large)",
      "force_cancel_large": "Force cancel (large)",
      "bulk_suspend_merchants": "Bulk suspend merchants",
      "bulk_delete": "Bulk delete",
      "gateway_key_rotation": "Gateway key rotation",
      "maintenance_mode_toggle": "Maintenance mode",
      "feature_flag_prod_toggle": "Feature flag (production)",
      "kek_rotation": "KEK rotation",
      "audit_log_export": "Audit log export",
      "impersonate_to_superadmin": "Impersonate Super Admin",
      "credit_grant_large": "Credit grant (large)",
      "pricing_tier_change_large": "Pricing tier change (large)",
      "weight_formula_change": "Weight formula change",
      "credit_memo_approve": "Credit memo approve"
    },
    "statusLabels": {
      "pending": "Pending",
      "approved": "Approved",
      "executed": "Executed",
      "rejected": "Rejected",
      "expired": "Expired"
    },
    "card": {
      "initiatedBy": "Initiated by",
      "reasonLabel": "Reason:",
      "payloadPreview": "Payload preview",
      "approvalsProgress": "{{n}} / {{required}} approvals",
      "singleSaExemption": "Single-SA exemption",
      "singleSaExemptionTooltip": "Per, the single active Super Admin may self-approve as an exemption",
      "threshold": "Threshold {{currency}} {{amount}}",
      "revalidating": "Re-validating…",
      "revalidateDiff": "Re-validate diff",
      "revalidateError": "Re-validate error",
      "revalDiffTitle": "Re-validation diff — requested vs current state",
      "close": "Close",
      "diffHighlightTitle": "Highlight changes since initiate",
      "noEffectiveState": "No effective state data yet — click Re-validate to fetch.",
      "selfApproveNotice": "You initiated this request — you cannot approve your own request.",
      "alreadyVoted": "You have already voted on this request.",
      "approveCommentLabel": "Approve comment (minimum 10 characters)",
      "approveCommentPlaceholder": "Approval reason (≥10 characters)",
      "approving": "Approving…",
      "approve": "Approve",
      "reject": "Reject",
      "rejectReasonLabel": "Rejection reason (minimum 10 characters)",
      "rejectReasonPlaceholder": "Reason for rejecting this request (≥10 characters)",
      "rejecting": "Rejecting…",
      "confirmReject": "Confirm rejection"
    },
    "emergencyBar": {
      "title": "Emergency Mode Active",
      "scopeLabel": "Scope:",
      "autoExpires": "Auto-expires in {{countdown}}",
      "aborting": "Aborting…",
      "abort": "Abort",
      "scope": {
        "production": "Production (orders + payments)",
        "security": "Security (sessions + KEK + IP)",
        "maintenance": "Maintenance (cron + workers)"
      }
    }
  },
  "security": {
    "severityLabels": {
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "critical": "Critical"
    },
    "statusLabels": {
      "open": "New",
      "dismissed": "Dismissed",
      "resolved": "Resolved"
    },
    "cancel": "Cancel",
    "anomaly": {
      "title": "Anomaly alerts",
      "totalAria": "Total events: {{total}}",
      "eventCount_one": "{{count}} event",
      "eventCount_other": "{{count}} events",
      "severityFilter": "Severity",
      "statusFilter": "Status",
      "all": "All",
      "refresh": "Refresh",
      "loadError": "Unable to load the alert list.",
      "dismissError": "Unable to dismiss the event.",
      "loading": "Loading...",
      "empty": "No alerts.",
      "dismiss": "Dismiss",
      "prev": "Previous",
      "next": "Next",
      "pageInfo": "Page {{page}} / {{totalPages}} — {{total}} events",
      "columns": {
        "time": "Time",
        "rule": "Rule",
        "severity": "Severity",
        "actor": "Actor",
        "sourceIp": "Source IP",
        "status": "Status",
        "actions": "Actions"
      },
      "dismissDialog": {
        "title": "Dismiss alert",
        "bodyBefore": "Enter a reason to dismiss the event ",
        "bodyAfter": ". This action will be recorded in the audit log.",
        "reasonLabel": "Reason (minimum 10 characters)",
        "saving": "Saving...",
        "confirm": "Confirm dismissal"
      }
    },
    "emergency": {
      "title": "Emergency Mode",
      "subtitle": "Super Admin only. Requires a 2FA code. Auto-expires after 2 hours.",
      "activeBadge": "ACTIVE — {{scope}}",
      "inactiveBadge": "Not active",
      "activatedBy": "Activated by",
      "startedAt": "Started",
      "autoExpiresAt": "Auto-expires",
      "remaining": "Remaining",
      "allowedActions": "Allowed actions:",
      "abortNow": "Abort now",
      "normalState": "The system is operating normally — no Emergency Mode is active.",
      "activateBtn": "Activate Emergency Mode",
      "superAdminOnly": "Only Super Admin can activate.",
      "expired": "Expired",
      "activateError": "Unable to activate Emergency Mode.",
      "abortError": "Unable to abort Emergency Mode.",
      "activateTitle": "Activate Emergency Mode",
      "activateBody": "This action will change security configuration system-wide. Requires a 2FA code. Auto-expires after 2 hours. Every action is logged to the audit log.",
      "scopeField": "Scope",
      "totpLabel": "2FA code (6 digits)",
      "reasonLabel20": "Reason (≥ 20 characters)",
      "activating": "Activating...",
      "confirmActivate": "Confirm activation",
      "abortTitle": "Abort Emergency Mode",
      "abortBody": "This action will disable it immediately. The audit log will record the reason.",
      "reasonLabel10": "Reason (≥ 10 characters)",
      "aborting": "Aborting...",
      "confirmAbort": "Confirm abort",
      "scopeLabels": {
        "production": "Production — block non-critical data writes",
        "security": "Security — bulk IP block + force revoke sessions",
        "maintenance": "Maintenance — block merchant/vendor writes"
      }
    }
  },
  "emailTemplates": {
    "testSend": {
      "ariaLabel": "Test send email template",
      "title": "Test send template",
      "bodyBefore": "Render ",
      "bodyAfter": " with a sample payload and send to a QA address.",
      "langLabel": "Language",
      "toEmailLabel": "Recipient email",
      "payloadLabel": "Sample payload (JSON)",
      "sending": "Sending…",
      "sendTest": "Send Test",
      "cancel": "Cancel",
      "errPayloadObject": "Sample payload must be a JSON object.",
      "errPayloadJson": "Invalid JSON — check the syntax.",
      "errEmailRequired": "Please enter a recipient email.",
      "errMissingVars": "Missing required variables: {{vars}}",
      "toastSuccessTitle": "Test mail sent",
      "toastSuccessDesc": "To {{email}} • message_id {{messageId}}…",
      "toastFailTitle": "Failed to send test mail",
      "toastUnknownError": "Unknown error. Please try again."
    }
  },
  "upload": {
    "networkError": "Could not connect to the server.",
    "failed": "File upload failed."
  }
}
